module.exports = __webpack_public_path__ + "public/img/人员布控.12d4456a.png";